export enum RemarkAuthorType {
    WORKER = 'WORKER',
    COORDINATOR = 'COORDINATOR',
    HR = 'HR',
}
